import { Typography } from '@mui/material';

import { StatusIcon } from '@/components/DataDisplay/StatusIcon';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectLoggedInUser } from '@/redux/auth/selectors';

import { DocumentStatus } from '@/types/document';

import { ReviewAndSubmitContent } from './ReviewAndSubmitContent';

import {
  ReviewSubmitCard,
  ReviewSubmitCardHeader,
} from './ReviewAndSubmit.styled';

type ReviewAndSubmitCardProps = {
  disabled?: boolean;
};

export function ReviewAndSubmitCard({
  disabled,
}: Readonly<ReviewAndSubmitCardProps>) {
  const { t } = useTranslate();
  const user = useAppSelector(selectLoggedInUser);
  const isConfirmed = !!user?.infoAccuracyConfirmed;

  let description = t('moreInfo.form.warranty.description.active');
  if (disabled) {
    description = t('moreInfo.form.warranty.description.inactive');
  } else if (isConfirmed) {
    description = t('status.completed');
  }

  const signatureIcon =
    isConfirmed && !disabled ? (
      <StatusIcon value={DocumentStatus.Approved} />
    ) : (
      <StatusIcon
        value=""
        iconName="signature"
        color={theme =>
          disabled ? theme.palette.neutral[700] : theme.palette.primaries[400]
        }
        backgroundColor={theme =>
          disabled ? theme.palette.neutral[200] : theme.palette.primaries[100]
        }
      />
    );

  return (
    <ReviewSubmitCard>
      <ReviewSubmitCardHeader>
        <div>
          <Typography variant="headlineH5">
            {t('moreInfo.form.warranty.reviewAndSubmit.title')}
          </Typography>
          <Typography
            variant="captionC1Regular"
            color="neutral.600"
            mt={0.5}
            display="block"
          >
            {description}
          </Typography>
        </div>
        {signatureIcon}
      </ReviewSubmitCardHeader>
      <ReviewAndSubmitContent disabled={disabled} />
    </ReviewSubmitCard>
  );
}
